<template>
    <v-container fluid>
        <v-row dense>
            <v-col cols="12">
                <v-tabs left v-model="tabMain">
                    <v-tab
                        v-if="$myStore.state.user.user_role_id != 3"
                        @click.native.prevent="changeTab('maritime-object-information')"
                        key="maritime-object-information"
                        href="#maritime-object-information"
                    >
                        {{ $t('tabs.maritimeObjectInformation') }}
                    </v-tab>
                    <v-tab
                        v-if="maritimeObject.id != 0 && $myStore.state.user.user_role_id == 1"
                        @click.native.prevent="changeTab('maritime-object-wage-template')"
                        key="maritime-object-wage-template"
                        href="#maritime-object-wage-template"
                    >
                        {{ $t('tabs.wageTemplate') }}
                    </v-tab>
                    <v-tab
                        v-if="maritimeObject.id != 0"
                        @click.native.prevent="changeTab('maritime-object-document-checklist')"
                        key="maritime-object-document-checklist"
                        href="#maritime-object-document-checklist"
                    >
                        {{ $t('tabs.documentChecklist') }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                        key="maritime-object-information"
                        value="maritime-object-information"
                        v-if="$myStore.state.user.user_role_id != 3"
                    >
                        <v-row>
                            <v-col class="pl-5 pt-6">
                                <v-btn
                                    v-if="inEditMode && maritimeObject.id != 0"
                                    class="ml-2 mr-2"
                                    color="primary"
                                    @click="saveClick(false)"
                                >
                                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                                </v-btn>
                                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                                </v-btn>
                                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                                </v-btn>
                                <v-btn class="mr-2" @click="backClick">
                                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                                </v-btn>
                            </v-col>

                            <v-col cols="12" v-if="maritimeObject.id == 0">
                                <v-card flat>
                                    <v-card-text class="pt-0 pb-0">
                                        <v-row dense>
                                            <v-col cols="2">
                                                <Dropdown
                                                    v-model="template_id"
                                                    :ajax="true"
                                                    :data="'maritime-objects'"
                                                    :label="$t('fields.loadFromTemplate')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-btn
                                                    class="ml-2 mr-2 mt-1"
                                                    color="primary"
                                                    @click="loadFromTemplate()"
                                                    :disabled="template_id == null"
                                                >
                                                    <v-icon class="mr-2" small>fas fa-paste</v-icon
                                                    >{{ $t('buttons.load') }}
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row
                            style="
                                margin-top: 3px;
                                margin-bottom: 0px;
                                scroll-margin: 0px;
                                height: 72vh;
                                overflow-y: scroll;
                                overflow-x: hidden;
                            "
                        >
                            <v-col cols="12" xl="6" lg="6" md="6">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.maritimeObjectDetails') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="5" v-if="maritimeObject.id != 0">
                                                <InputField
                                                    :readonly="true"
                                                    v-model="maritimeObject.id"
                                                    :label="$t('fields.id')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="2" class="pt-0">
                                                <CheckBox
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.active"
                                                    :label="$t('fields.active')"
                                                ></CheckBox>
                                            </v-col>
                                            <v-col v-if="maritimeObject.id != 0" cols="5"></v-col>
                                            <v-col v-if="maritimeObject.id == 0" cols="10"></v-col>

                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.maritime_object_type_id"
                                                    :ajax="true"
                                                    :data="'maritime-object-types'"
                                                    :errorBorder="!maritimeObjectValidation.maritime_object_type_id"
                                                    :label="'* ' + $t('fields.type')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="50"
                                                    v-model="maritimeObject.name"
                                                    :errorBorder="!maritimeObjectValidation.name"
                                                    :label="'* ' + $t('fields.name')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12" v-if="maritimeObject.maritime_object_type_id == 1">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="20"
                                                    v-model="vessel.imo"
                                                    :errorBorder="!vesselValidation.imo"
                                                    :label="'* ' + $t('fields.imo')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12" v-if="maritimeObject.maritime_object_type_id == 1">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="10"
                                                    v-model="vessel.call_sign"
                                                    :errorBorder="!vesselValidation.call_sign"
                                                    :label="$t('fields.callSign')"
                                                ></InputField>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card flat v-if="maritimeObject.maritime_object_type_id == 1">
                                    <v-card-title>
                                        {{ $t('labels.vesselDetails') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <Dropdown2
                                                    :readonly="!inEditMode"
                                                    v-model="vessel.registered_flag_id"
                                                    :ajax="true"
                                                    :data="'countries'"
                                                    :errorBorder="!vesselValidation.registered_flag_id"
                                                    :label="'*' + $t('fields.registeredFlag')"
                                                ></Dropdown2>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="100"
                                                    v-model="vessel.port_of_registry"
                                                    :errorBorder="!vesselValidation.port_of_registry"
                                                    :label="$t('fields.portOfRegistry')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="vessel.vessel_type_id"
                                                    :ajax="true"
                                                    :data="'vessel-types'"
                                                    :errorBorder="!vesselValidation.vessel_type_id"
                                                    :label="'*' + $t('fields.vesselType')"
                                                ></Dropdown>
                                            </v-col>
                                            <!-- <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="vessel.vessel_size_id"
                                                    :ajax="true"
                                                    :data="'vessel-sizes'"
                                                    :errorBorder="!vesselValidation.vessel_size_id"
                                                    :label="$t('fields.vesselSize')"
                                                ></Dropdown>
                                            </v-col> -->
                                            <v-col cols="6">
                                                <InputField
                                                    :maxlength="4"
                                                    :readonly="!inEditMode"
                                                    v-model="vessel.year_built"
                                                    :errorBorder="!vesselValidation.year_built"
                                                    :label="$t('fields.yearBuilt')"
                                                    @keyup.native="yearBuildCheck"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="6">
                                                <InputField
                                                    :readonly="true"
                                                    v-model="vessel_age"
                                                    :label="$t('fields.vesselAge')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="20"
                                                    v-model="vessel.dwt"
                                                    :errorBorder="!vesselValidation.dwt"
                                                    :label="$t('fields.dwt')"
                                                    @keypress.native="numbersOnly"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="20"
                                                    v-model="vessel.gt"
                                                    :errorBorder="!vesselValidation.gt"
                                                    :label="'* ' + $t('fields.gt')"
                                                    @keypress.native="numbersOnly"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="10"
                                                    v-model="vessel.loa"
                                                    :errorBorder="!vesselValidation.loa"
                                                    :label="$t('fields.loaM')"
                                                    @keypress.native="numbersOnly"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="100"
                                                    v-model="vessel.pumping_system"
                                                    :errorBorder="!vesselValidation.pumping_system"
                                                    :label="$t('fields.pumpingSystem')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="100"
                                                    v-model="vessel.cargo_handling_gear"
                                                    :errorBorder="!vesselValidation.cargo_handling_gear"
                                                    :label="$t('fields.cargoHandlingGear')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="20"
                                                    v-model="vessel.propulsion_power"
                                                    :errorBorder="!vesselValidation.propulsion_power"
                                                    :label="'* ' + $t('fields.propulsionPowerkW')"
                                                    @keypress.native="integersOnly"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="vessel.engine_type_id"
                                                    :ajax="true"
                                                    :data="'engine-types'"
                                                    :errorBorder="!vesselValidation.engine_type_id"
                                                    :label="$t('fields.engineType')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="50"
                                                    v-model="vessel.engine_model"
                                                    :errorBorder="!vesselValidation.engine_model"
                                                    :label="$t('fields.engineModel')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="vessel.dp_type_id"
                                                    :ajax="true"
                                                    :data="'dp-types'"
                                                    :errorBorder="!vesselValidation.dp_type_id"
                                                    :label="$t('fields.dpType')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="vessel.dp_manufacturer_id"
                                                    :ajax="true"
                                                    :data="'dp-manufacturers'"
                                                    :errorBorder="!vesselValidation.dp_manufacturer_id"
                                                    :label="$t('fields.dpManufacturer')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="50"
                                                    v-model="vessel.shipbuilder"
                                                    :errorBorder="!vesselValidation.shipbuilder"
                                                    :label="$t('fields.shipBuilder')"
                                                ></InputField>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.companies') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.maritime_object_owner_id"
                                                    :ajax="true"
                                                    :data="'entities'"
                                                    :errorBorder="!maritimeObjectValidation.maritime_object_owner_id"
                                                    :label="$t('fields.maritimeObjectOwner')"
                                                    :key="componentKey"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.maritime_object_manager_id"
                                                    :ajax="true"
                                                    :data="'entities'"
                                                    :errorBorder="!maritimeObjectValidation.maritime_object_manager_id"
                                                    :label="'* ' + $t('fields.maritimeObjectManager')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.client_id"
                                                    :ajax="true"
                                                    :data="'entities'"
                                                    :errorBorder="!maritimeObjectValidation.client_id"
                                                    :label="'* ' + $t('fields.client')"
                                                ></Dropdown>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.invoiceDetails') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.invoice_to_id"
                                                    :ajax="true"
                                                    :data="'entities'"
                                                    :errorBorder="!maritimeObjectValidation.invoice_to_id"
                                                    :label="'* ' + $t('fields.invoiceTo')"
                                                ></Dropdown>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.maritimeObjectContractDetails') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense>
                                            <v-radio-group :readonly="!inEditMode" v-model="employeerType" row>
                                                <v-radio
                                                    :label="$t('fields.entity')"
                                                    :value="1"
                                                    color="primary"
                                                ></v-radio>
                                                <v-radio
                                                    :label="$t('fields.internalOffice')"
                                                    :value="2"
                                                    color="primary"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-row>
                                        <v-row dense wrap>
                                            <v-col cols="12" v-if="employeerType == 2">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.internal_office_employer_id"
                                                    :ajax="true"
                                                    :data="'internal-offices'"
                                                    :errorBorder="!maritimeObjectValidation.internal_office_employer_id"
                                                    :label="'* ' + $t('fields.employer')"
                                                    :key="componentKey"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12" v-if="employeerType == 1">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="maritimeObject.employer_id"
                                                    :ajax="true"
                                                    :data="'entities'"
                                                    :errorBorder="!maritimeObjectValidation.employer_id"
                                                    :label="'* ' + $t('fields.employer')"
                                                    :key="componentKey"
                                                ></Dropdown>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.maritimeObjectContactDetails') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="50"
                                                    v-model="maritimeObject.email"
                                                    :errorBorder="!maritimeObjectValidation.email"
                                                    :label="$t('fields.email')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <TextArea
                                                    :readonly="!inEditMode"
                                                    :maxlength="500"
                                                    v-model="maritimeObject.details"
                                                    :errorBorder="!maritimeObjectValidation.details"
                                                    :label="$t('fields.details')"
                                                ></TextArea>
                                            </v-col>
                                            <v-col cols="12">
                                                <TextArea
                                                    :readonly="!inEditMode"
                                                    :maxlength="500"
                                                    v-model="maritimeObject.contract_header"
                                                    :label="$t('fields.contractHeader')"
                                                ></TextArea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.notes') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <TextArea
                                                    :readonly="!inEditMode"
                                                    :maxlength="500"
                                                    v-model="maritimeObject.notes"
                                                    :errorBorder="!maritimeObjectValidation.notes"
                                                    :label="$t('fields.notes')"
                                                ></TextArea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                        key="maritime-object-wage-template"
                        value="maritime-object-wage-template"
                        v-if="$myStore.state.user.user_role_id == 1"
                        ><WageTemplate
                            :maritimeObject="maritimeObject"
                            :inEditMode="inEditMode"
                            @edit="editForTab()"
                        ></WageTemplate
                    ></v-tab-item>
                    <v-tab-item key="maritime-object-document-checklist" value="maritime-object-document-checklist"
                        ><MaritimeObjectDocumentChecklist
                            :maritimeObject="maritimeObject"
                            :inEditMode="inEditMode"
                            @edit="editForTab()"
                        ></MaritimeObjectDocumentChecklist
                    ></v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import Dropdown2 from './trinkets/Dropdown2';
import InputField from './trinkets/InputField';
import MaritimeObject from '../models/MaritimeObject';
import TextArea from '@/components/trinkets/TextArea';
import Vessel from '../models/Vessel';
import WageTemplate from '@/components/MaritimeObjectWageTemplate';
import MaritimeObjectDocumentChecklist from './MaritimeObjectDocumentChecklist.vue';

export default {
    name: 'MaritimeObject',
    components: {CheckBox, Dropdown, Dropdown2, InputField, TextArea, WageTemplate, MaritimeObjectDocumentChecklist},
    data: function () {
        return {
            maritimeObject: new MaritimeObject({id: this.$route.params.id}),
            maritimeObjectValidation: new MaritimeObject({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'maritime-object-information',
            lockTimer: null,
            template_id: null,
            vessel_age: '',
            vessel: new Vessel({}),
            vesselValidation: new Vessel({}, true),
            thisYear: 0,
            tabMain: 'maritime-object-information',
            tab: 'maritime-object-information',
            currentTab: 'maritime-object-information',
            employeerType: 1,
            componentKey: 1,
        };
    },
    watch: {
        employeerType: {
            handler: function () {
                this.componentKey++;
            },
            deep: true,
        },
    },
    methods: {
        changeTab(id) {
            this.tabMain = this.currentTab;
            if (this.inEditMode) {
                let vm = this;
                this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                    if (result) {
                        clearInterval(vm.lockTimer);
                        this.$removeLock(this, this.lockKey + '|' + this.maritimeObject.id);
                        this.tabMain = id;
                        this.tab = id;
                        this.currentTab = id;
                        switch (this.tabMain) {
                            case 'maritime-object-information':
                                this.lockKey = 'maritime-object-information';
                                break;
                            case 'maritime-object-wage-template':
                                this.lockKey = 'maritime-object-wage-template';
                                break;
                            case 'maritime-object-document-checklist':
                                this.lockKey = 'maritime-object-document-checklist';
                                break;
                            default:
                                break;
                        }
                        vm.inEditMode = false;
                    }
                });
            } else {
                this.tabMain = id;
                this.tab = id;
                this.currentTab = id;
                switch (this.tabMain) {
                    case 'maritime-object-information':
                        this.lockKey = 'maritime-object-information';
                        break;
                    case 'maritime-object-wage-template':
                        this.lockKey = 'maritime-object-wage-template';
                        break;
                    case 'maritime-object-document-checklist':
                        this.lockKey = 'maritime-object-document-checklist';
                        break;
                    default:
                        break;
                }
            }
        },
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.maritimeObject.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.maritimeObject.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },

        editForTab() {
            let vm = this;
            if (this.inEditMode == true) {
                clearInterval(vm.lockTimer);
                this.$removeLock(this, this.lockKey + '|' + this.maritimeObject.id);
            } else {
                this.editClick();
            }
            this.inEditMode = !this.inEditMode;
        },

        integersOnly(evt) {
            if (!/^[0-9]$/.test(evt.key)) {
                evt.preventDefault();
            }
        },

        numbersOnly(evt) {
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        backClick() {
            this.$router.go(-1);
        },

        loadFromTemplate() {
            let vm = this;
            this.$APICall('get', 'maritime-objects/' + this.template_id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.maritimeObject = usableData;
                    vm.maritimeObject.id = 0;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.maritimeObjects'),
                            href: '/#/maritime-objects',
                            disabled: false,
                        },
                        {
                            text: vm.maritimeObject.name + ' (' + vm.maritimeObject.id + ')',
                            href: '/#/maritime-objects/' + vm.maritimeObject.id,
                            disabled: true,
                        },
                    ]);
                    if (vm.maritimeObject.maritime_object_type_id == 1) {
                        vm.$APICall('get', 'vessels/' + vm.maritimeObject.vessel_id, {}, (data, succes) => {
                            if (succes) {
                                let vesseldata = JSON.parse(JSON.stringify(data));
                                vm.vessel = vesseldata;
                                vm.vessel.id = 0;
                                const d = new Date();
                                d.setFullYear(vm.vessel.year_built, 0, 1);
                                const now = new Date();
                                let diff = d - now;
                                diff = (diff / 31536000000) * -1;
                                vm.vessel_age = diff.toFixed(1) + ' years';
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        });
                    }
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },

        saveClick(goBack) {
            let success = true;
            let missingFields = '';

            if (this.maritimeObject.name == '') {
                success = false;
                this.maritimeObjectValidation.name = false;
                missingFields += this.$t('fields.name') + '<br/>';
            } else {
                this.maritimeObjectValidation.name = true;
            }
            if (this.maritimeObject.maritime_object_type_id == null) {
                success = false;
                this.maritimeObjectValidation.maritime_object_type_id = false;
                missingFields += this.$t('fields.type') + '<br/>';
            } else {
                this.maritimeObjectValidation.maritime_object_type_id = true;
            }
            if (this.maritimeObject.maritime_object_manager_id == null) {
                success = false;
                this.maritimeObjectValidation.maritime_object_manager_id = false;
                missingFields += this.$t('fields.maritimeObjectManager') + '<br/>';
            } else {
                this.maritimeObjectValidation.maritime_object_manager_id = true;
            }
            if (this.maritimeObject.client_id == null) {
                success = false;
                this.maritimeObjectValidation.client_id = false;
                missingFields += this.$t('fields.client') + '<br/>';
            } else {
                this.maritimeObjectValidation.client_id = true;
            }
            if (this.maritimeObject.invoice_to_id == null) {
                success = false;
                this.maritimeObjectValidation.invoice_to_id = false;
                missingFields += this.$t('fields.invoiceTo') + '<br/>';
            } else {
                this.maritimeObjectValidation.invoice_to_id = true;
            }
            if (this.employeerType == 1) {
                this.maritimeObject.internal_office_employer_id = null;
                if (this.maritimeObject.employer_id == null) {
                    success = false;
                    this.maritimeObjectValidation.employer_id = false;
                    missingFields += this.$t('fields.employer') + '<br/>';
                } else {
                    this.maritimeObjectValidation.employer_id = true;
                }
            } else {
                this.maritimeObject.employer_id = null;
                if (this.maritimeObject.internal_office_employer_id == null) {
                    success = false;
                    this.maritimeObjectValidation.internal_office_employer_id = false;
                    missingFields += this.$t('fields.employer') + '<br/>';
                } else {
                    this.maritimeObjectValidation.internal_office_employer_id = true;
                }
            }
            if (this.maritimeObject.email != '' && this.maritimeObject.email != null) {
                if (!this.$checkEmail(this.maritimeObject.email)) {
                    success = false;
                    this.maritimeObjectValidation.email = false;
                    missingFields += this.$t('alerts.emailFailFormat') + '<br/>';
                } else {
                    this.maritimeObjectValidation.email = true;
                }
            } else {
                this.maritimeObjectValidation.email = true;
            }

            if (this.maritimeObject.maritime_object_type_id == 1) {
                for (const key of Object.keys(this.vessel)) {
                    if (typeof this.vessel[key] == 'string') {
                        this.vessel[key] = this.vessel[key].trim();
                    }
                }
                if (this.vessel.registered_flag_id == null) {
                    success = false;
                    this.vesselValidation.registered_flag_id = false;
                    missingFields += this.$t('fields.registeredFlag') + '<br/>';
                } else {
                    this.vesselValidation.registered_flag_id = true;
                }
                if (this.vessel.vessel_type_id == null) {
                    success = false;
                    this.vesselValidation.vessel_type_id = false;
                    missingFields += this.$t('fields.vesselType') + '<br/>';
                } else {
                    this.vesselValidation.vessel_type_id = true;
                }
                if (this.vessel.gt == '') {
                    success = false;
                    this.vesselValidation.gt = false;
                    missingFields += this.$t('fields.gt') + '<br/>';
                } else {
                    this.vesselValidation.gt = true;
                }
                if (this.vessel.propulsion_power != null) {
                    this.vessel.propulsion_power = this.vessel.propulsion_power.toString().replace(/[\s,]/g, '');
                }
                if (!/^\d+$/.test(this.vessel.propulsion_power)) {
                    success = false;
                    this.vesselValidation.propulsion_power = false;
                    missingFields += this.$t('fields.propulsionPowerkW') + '<br/>';
                } else {
                    this.vesselValidation.propulsion_power = true;
                }
                if (
                    this.vessel.imo == null ||
                    this.vessel.imo == '' ||
                    this.vessel.imo.length < 1 ||
                    this.vessel.imo.length > 20
                ) {
                    success = false;
                    this.vesselValidation.imo = false;
                    missingFields += this.$t('fields.imo') + '<br/>';
                } else {
                    this.vesselValidation.imo = true;
                }
            } else {
                this.$alert(this.$t('alerts.onshoreFacilityNotDefined'));
                return;
            }

            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                let additionVessel = '';
                if (vm.maritimeObject.id != 0) {
                    action = 'put';
                    addition = '/' + vm.maritimeObject.id;
                    additionVessel = '/' + vm.vessel.id;
                }
                if (this.maritimeObject.maritime_object_type_id == 1) {
                    this.$APICall(action, 'vessels' + additionVessel, this.vessel, (data, succes) => {
                        if (succes) {
                            vm.maritimeObject.vessel_id = data['vessel_id'];
                            vm.vessel.id = data['vessel_id'];
                            vm.$APICall(action, 'maritime-objects' + addition, vm.maritimeObject, (data, success) => {
                                if (success) {
                                    let wasNew = vm.maritimeObject.id == 0;
                                    vm.inEditMode = false;
                                    if (wasNew) {
                                        vm.maritimeObject.id = data.id;
                                        vm.$notify(vm.$t('alerts.basicAdd'));
                                        vm.$myStore.commit('setBreadcrumbs', [
                                            {
                                                text: vm.$t('modules.maritimeObjects'),
                                                href: '/#/maritime-objects',
                                                disabled: false,
                                            },
                                            {
                                                text: vm.maritimeObject.name + ' (' + vm.maritimeObject.id + ')',
                                                href: '/#/maritime-objects/' + vm.maritimeObject.id,
                                                disabled: true,
                                            },
                                        ]);
                                    } else {
                                        vm.$notify(vm.$t('alerts.basicUpdate'));
                                    }
                                    if (this.lockTimer !== null) clearInterval(this.lockTimer);
                                    vm.$removeLock(vm, vm.lockKey + '|' + vm.maritimeObject.id);
                                    vm.$triggerReload();
                                    if (goBack) {
                                        vm.backClick();
                                    }
                                } else {
                                    vm.$alert(vm.$t('alerts.basicError'));
                                }
                            });
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    });
                }
            } else {
                let alert = this.$t('alerts.missingFields') + '<br/> ' + missingFields;
                this.$alert(alert);
            }
        },

        yearBuildCheck(evt) {
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            }
            if (this.vessel.year_built > this.thisYear || this.vessel.year_built.length < 4) {
                this.vesselValidation.year_built = false;
            } else {
                this.vesselValidation.year_built = true;
                const d = new Date();
                d.setFullYear(this.vessel.year_built, 0, 1);
                const now = new Date();
                let diff = d - now;
                diff = (diff / 31536000000) * -1;
                this.vessel_age = diff.toFixed(1) + ' years';
            }
            if (this.vessel.year_built == '') {
                this.vesselValidation.year_built = true;
                this.vessel_age = '';
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    let elHtml = document.getElementsByTagName('html')[0];
                    elHtml.style.overflowY = 'auto';
                    if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
                    vm.$removeLock(vm, vm.lockKey + '|' + vm.maritimeObject.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            let elHtml = document.getElementsByTagName('html')[0];
            elHtml.style.overflowY = 'auto';
            if (this.lockTimer !== null) clearInterval(this.lockTimer);
            this.$removeLock(this, this.lockKey + '|' + this.maritimeObject.id);
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let elHtml = document.getElementsByTagName('html')[0];
        elHtml.style.overflowY = 'hidden';
        let vm = this;
        if (this.maritimeObject.id != 0) {
            if (this.$myStore.state.user.user_role_id == 2) {
                this.tabMain = 'maritime-object-wage-template';
                this.tab = 'maritime-object-wage-template';
                this.currentTab = 'maritime-object-wage-template';
            } else if (this.$myStore.state.user.user_role_id == 3) {
                this.tabMain = 'maritime-object-document-checklist';
                this.tab = 'maritime-object-document-checklist';
                this.currentTab = 'maritime-object-document-checklist';
            }
            this.$APICall('get', 'maritime-objects/' + this.maritimeObject.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.maritimeObject = usableData;
                    if (this.maritimeObject.internal_office_employer_id == null) {
                        this.employeerType = 1;
                    } else {
                        this.employeerType = 2;
                    }
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.maritimeObjects'),
                            href: '/#/maritime-objects',
                            disabled: false,
                        },
                        {
                            text: vm.maritimeObject.name + ' (' + vm.maritimeObject.id + ')',
                            href: '/#/maritime-objects/' + vm.maritimeObject.id,
                            disabled: true,
                        },
                    ]);
                    if (vm.maritimeObject.maritime_object_type_id == 1) {
                        vm.$APICall('get', 'vessels/' + vm.maritimeObject.vessel_id, {}, (data, succes) => {
                            if (succes) {
                                let vesseldata = JSON.parse(JSON.stringify(data));
                                vm.vessel = vesseldata;
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        });
                    }
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.maritimeObjects'),
                    href: '/#/maritime-objects',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newMaritimeObject'),
                    href: '/#/maritime-objects/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
        this.thisYear = new Date().getFullYear();
    },
};
</script>

<style scoped></style>
